<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <div
          class="items"
          v-scroll-spy-link="{ selector: 'a', class: 'btn-primary' }"
          v-scroll-spy-active="{ selector: 'a div', class: 'btn-primary' }"
        >
          <div class="items">
            <a href="#general">
              <div class="btn w-100 btn-simple text-start">General</div>
            </a>
          </div>
        </div>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10" v-scroll-spy="{ offset: 120 }">
      <section id="general">
        <h2>Collection settings</h2>
        <p class="text-muted mb-4">
          Configure how orders are prioritized during warehouse
          collection/picking.
        </p>

        <div class="row mt-4">
          <div class="col-4">Date priority</div>
          <div class="col-8">
            <input
              type="number"
              class="form-control"
              v-model.number="collectionDatePoint"
              min="0"
              max="999"
              step="0.01"
            />
            <small class="text-muted"
              >Weight for order age. Higher = older orders get more priority.
              (Default: 1)</small
            >
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-4">Product similarity priority</div>
          <div class="col-8">
            <input
              type="number"
              class="form-control"
              v-model.number="collectionProductPoint"
              min="0"
              max="999"
              step="0.01"
            />
            <small class="text-muted"
              >Weight for similar product grouping. Higher = similar products
              grouped together. (Default: 0.01)</small
            >
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-4">Delivery point priority</div>
          <div class="col-8">
            <input
              type="number"
              class="form-control"
              v-model.number="collectionDeliveryPoint"
              min="0"
              max="999"
              step="0.01"
            />
            <small class="text-muted"
              >Weight for carrier/delivery point. Higher = preferred carriers
              get priority. (Default: 0.1)</small
            >
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-4"></div>
          <div class="col-8">
            <button class="btn btn-primary" @click="save" :disabled="saving">
              {{ saving ? "Saving..." : "Save settings" }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";

export default {
  name: "CollectionSettings",
  data() {
    return {
      collectionDatePoint: 1,
      collectionProductPoint: 0.01,
      collectionDeliveryPoint: 0.1,
      saving: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      http.fetch("/collection-settings").then((data) => {
        this.collectionDatePoint = data.collection_date_point;
        this.collectionProductPoint = data.collection_product_point;
        this.collectionDeliveryPoint = data.collection_delivery_point;
      });
    },
    save() {
      this.saving = true;
      http
        .fetch(
          "/collection-settings",
          {
            collection_date_point: this.collectionDatePoint,
            collection_product_point: this.collectionProductPoint,
            collection_delivery_point: this.collectionDeliveryPoint,
          },
          true,
          "POST"
        )
        .then(() => {
          this.saving = false;
        })
        .catch(() => {
          this.saving = false;
        });
    },
  },
};
</script>
